import { render } from "./PriceServiceDetailRemarkEdit.vue?vue&type=template&id=d3214bbe&scoped=true&ts=true"
import script from "./PriceServiceDetailRemarkEdit.vue?vue&type=script&lang=ts"
export * from "./PriceServiceDetailRemarkEdit.vue?vue&type=script&lang=ts"

import "./PriceServiceDetailRemarkEdit.vue?vue&type=style&index=0&id=d3214bbe&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3214bbe"]])

export default __exports__